import { transition, trigger, useAnimation } from '@angular/animations'
import { Component } from '@angular/core'
import { fadeAnimation, staggerAnimation } from '@src/app/core/util/animations.util.js'

@Component({
  selector: 'info-popup',
  templateUrl: './info-popup.component.html',
  styleUrls: ['./info-popup.component.scss'],
  animations: [
    trigger('fadeAnimation', [transition('* => *', [useAnimation(fadeAnimation)])]),
    trigger('staggerAnimation', [transition('* => *', [useAnimation(staggerAnimation)])]),
  ],
  standalone: false,
})
export class InfoPopupComponent {}
